/* eslint-disable array-callback-return */
// 组通知历史记录
import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import { Drawer, List, Empty, message as toast } from "antd";
import "./index.less";
import { useTranslation } from "react-i18next";
import { Avatar } from "@/baseComponents/Avatar";
import { pageNotificationList } from "@/api/notification";
import { formate } from "@/utils/date";
import noticeImg from "@/assets/img/no-content.png";
import { connect } from "dvajs";
import { changeEgovUrl } from "@/utils/tools";
import ScrollView from "@/baseComponents/ScrollView";
import colors from "@/components/styles/colors";
import ChatState from "@/types/chat/State";
interface IPropss {
  openNoticeDetails: (data: { isvisibles: boolean; notificationId: any; type?: string }) => void;
  openNoticeDetailsHis: (data: { isvisibles: boolean; sessionId: any }) => void;
}
type IProps = Readonly<IPropss & ChatState>;
let count = 0;
let historyList: any;
function History(props: IProps) {
  const { openNoticeDetails, NoticeHisVisible, NoticeDetailsHisId, openNoticeDetailsHis } = props;
  const scrollRef = useRef(null);
  const [t] = useTranslation("chat");
  const [notificationList, setNotificationList] = useState<any>([]);
  const [scrollEnd, setScrollEnd] = useState(false);
  const listData = [];

  const getPageNotificationList = useCallback(async () => {
    const [data, err] = await pageNotificationList({
      sourceType: 1,
      sourceBizId: NoticeDetailsHisId,
      offset: count,
      limit: 20
    });
    // console.log('查看历史', data, err);
    if (err) {
      toast.error(err);
      return;
    }
    if (data.notificationList.length === 0) {
      setScrollEnd(true);
      return;
    }
    if (data) {
      historyList = historyList ? historyList.concat(data.notificationList) : data.notificationList;
      setNotificationList(historyList);
    }
  }, [NoticeDetailsHisId]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (NoticeHisVisible === true) {
      count = 0;
      historyList = [];
      getPageNotificationList();
    }
  }, [getPageNotificationList, NoticeHisVisible]);

  const onScroll = () => {
    const cu: any = scrollRef.current;
    if (!cu) {
      return;
    }
    const scrollHeight = cu.getScrollHeight();
    const scrollTop = cu.getScrollTop();
    const { clientHeight } = cu.getValues();
    if (scrollHeight - clientHeight - scrollTop === 0) {
      if (scrollEnd) return;
      count++;
      getPageNotificationList();
    }
  };

  const hadleOpendel = (item: any) => {
    openNoticeDetails({
      isvisibles: true,
      notificationId: item.notificationId,
      type: "history"
    });
  };

  const onClose = () => {
    openNoticeDetailsHis({
      isvisibles: false,
      sessionId: ""
    });
    setNotificationList([]);
  };

  if (notificationList === undefined) return null;
  // eslint-disable-next-line @typescript-eslint/prefer-for-of
  for (let i = 0; i < notificationList.length; i++) {
    listData.push({
      title: (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <span
            style={{
              width: "200px"
            }}
            className="ellipsis"
          >
            {notificationList[i].realName}
          </span>
          <span
            style={{
              fontSize: "11px",
              color: "#62656d",
              height: "18px",
              lineHeight: "18px"
            }}
          >
            发布于 {formate(notificationList[i].gmtCreate)}
          </span>
        </div>
      ),
      avatar: (
        <Avatar
          name={`${notificationList[i].realName}`}
          className="imgAvatar"
          src={changeEgovUrl(notificationList[i].headImg)}
        />
      ),
      realName: `${notificationList[i].realName}`,
      notificationId: `${notificationList[i].notificationId}`,
      content: (
        <div>
          <p className="history_con" style={{ whiteSpace: "pre-wrap", color: `${colors.black2}` }}>
            {notificationList[i].content}
          </p>
          {/* <br /> */}
          <div style={{ marginTop: "7px" }}>
            <span style={{ color: "#8F959E", marginRight: "30px" }}>
              已回复 {notificationList[i].repliedNum}
            </span>
            <span style={{ color: "#8F959E" }}>未回复 {notificationList[i].unansweredNum}</span>
          </div>
        </div>
      )
    });
  }
  return (
    <>
      <Drawer
        className="DrawerHistorybox"
        width={540}
        title={t("group_tz")}
        placement="right"
        onClose={onClose}
        visible={NoticeHisVisible}
      >
        {notificationList.length > 0 ? (
          <ScrollView onScroll={onScroll} ref={scrollRef}>
            <List
              itemLayout="vertical"
              size="large"
              dataSource={listData}
              split={false}
              renderItem={(item: any) => (
                <List.Item>
                  <List.Item.Meta
                    avatar={item.avatar}
                    title={item.title}
                    description={item.description}
                  />
                  {item.content}
                  <div
                    style={{
                      position: "absolute",
                      top: "0",
                      left: "0",
                      width: "100%",
                      height: "100%",
                      cursor: "pointer"
                    }}
                    onClick={() => {
                      hadleOpendel(item);
                    }}
                  />
                </List.Item>
              )}
            />
          </ScrollView>
        ) : (
          <Empty
            image={noticeImg}
            imageStyle={{
              height: 100
            }}
            description={<span style={{ color: "#62656D" }}>暂无群通知</span>}
          />
        )}
      </Drawer>
      {/* {isvisible && <NoticeDetails />} */}
    </>
  );
}
function mapStateToProps({ chat }: { chat: ChatState }) {
  const { NoticeHisVisible, NoticeDetailsHisId } = chat;
  return {
    NoticeHisVisible,
    NoticeDetailsHisId
  };
}
function mapDispatchToProps(dispatch: any) {
  return {
    openNoticeDetails(data: { isvisibles: boolean; notificationId: any; type?: string }) {
      dispatch({ type: "chat/openNoticeDetails", payload: data });
    },
    openNoticeDetailsHis(data: { isvisibles: boolean; sessionId: any }) {
      dispatch({ type: "chat/openNoticeDetailsHis", payload: data });
    }
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(History);
